import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

import FormWithProvider from 'components/forms/form/Form';
import TextAreaField from 'components/forms/textAreaField/TextAreaField';
import ModalFormCancelButton from 'components/modal/form/ModalFormCancelButton';
import ModalFormSubmitButton from 'components/modal/form/ModalFormSubmitButton';
import usePropertySettingsInitData from 'pages/property/usePropertySettingsInitData';
import { propertySettingsMainTabSchema } from '../../PropertySettingsMainTab.schema';
import { AirbnbSettings } from '../../PropertySettingsMainTab.types';
import { SetInstructionsFieldsetStyled } from './AirbnbSettings.styles';

interface SetInstructionsModalProps {
  defaultValues: Pick<AirbnbSettings, 'checkInOptionInstruction'>;
  onSubmit: (values: Pick<AirbnbSettings, 'checkInOptionInstruction'>) => void;
}

const SetInstructionsModal = ({
  defaultValues,
  onSubmit,
}: SetInstructionsModalProps) => {
  const { t } = useTranslation();
  const { property } = usePropertySettingsInitData();
  const schema = Yup.object({
    checkInOptionInstruction: Yup.reach(
      propertySettingsMainTabSchema(property?.businessType!, t),
      'airbnbSettings.checkInOptionInstruction',
    ),
  });

  return (
    <div data-testid="set-instructions-modal">
      <Modal.Header data-testid="modal-header" closeButton>
        <Modal.Title>
          {t('pageProperty.mainSettings.airbnbSettings.setInstructions')}
        </Modal.Title>
      </Modal.Header>
      <FormWithProvider
        defaultValues={defaultValues}
        onSubmit={onSubmit}
        resolver={schema}
        noValidate
      >
        <Modal.Body data-testid="modal-body">
          <SetInstructionsFieldsetStyled>
            <TextAreaField
              label={t(
                'pageProperty.mainSettings.airbnbSettings.checkInOptionInstruction',
              )}
              labelOnTop
              maxCharacters={1000}
              maxLength={1000}
              name="checkInOptionInstruction"
            />
          </SetInstructionsFieldsetStyled>
        </Modal.Body>

        <Modal.Footer>
          <ModalFormCancelButton />
          <ModalFormSubmitButton>{t('common.apply')}</ModalFormSubmitButton>
        </Modal.Footer>
      </FormWithProvider>
    </div>
  );
};

export default SetInstructionsModal;
